// Essential Mixins
import { SafeIdMixin }          from './System/safeID.js'
import Controller               from './System/controller.js' 
import draw_Canvas              from './System/draw_Canvas.js'
import draw_Movable             from './System/draw_Movable.js'
import func_Global              from './System/func_Global.js'

// Append
import app_index                from './app_index.js'
import app_Func                 from './app_Func.js'
import app_Graphics             from './app_Graphics.js'
import app_Images               from './app_Images.js'
import app_barChart             from './app_barChart.js'
import app_Texts                from './app_Texts.js'

// Dwawing
import draw_Compound            from './draw_Compound.js'
import draw_SearchTool          from './draw_SearchTool.js'
import draw_Element             from './draw_Element.js'

// Functions
import func_Date                from './func_Date.js'
import func_Getters             from './func_Getter.js'
import func_Updates             from './func_Updates.js'
import func_callEvents          from './func_callEvents.js'

// set_InitValues
import init_Timeline            from './init_Timeline.js'
import init_Skyline             from './init_Skyline.js'
import init_Colors              from './init_Colors.js'

// Forms
import forms_datePicker         from './forms/datePicker.js'
import forms_dropDown           from './forms/dropDown.js'
import forms_inputBox           from './forms/inputBox.js'
import forms_openPopup          from './forms/openPopup.js'
import forms_openWindow         from './forms/openWindow.js'



export default {
  
  mixins: [
    SafeIdMixin, 
    Controller,
    draw_Canvas,
    draw_Movable,
    func_Global,

    // Appends
    app_index,
    app_Func,
    app_Graphics,
    app_Images,
    app_barChart,
    app_Texts,

    // Drawings
    draw_Compound,
    draw_SearchTool,
    draw_Element,
    
    // Functions
    func_Date,
    func_Getters,
    func_Updates,
    func_callEvents,
    
    // set_InitValues
    init_Timeline,
    init_Skyline,
    init_Colors,

    // Forms
    forms_datePicker,
    forms_dropDown,
    forms_inputBox,
    forms_openPopup,
    forms_openWindow,
  ],

}
